import { Link } from "react-router-dom";
import { featuredMovies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

export default function FeaturedMovies() {
  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              高分推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">口碑爆棚的经典佳作</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredMovies.map((movie) => (
            <MovieCard
              key={movie.id}
              {...movie}
              showBadge
              badgeText="高分"
            />
          ))}
        </div>
      </div>
    </section>
  );
}